var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWallet3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "active-color-2",
    d: "M12.4993 5.12504H4.99935C3.15768 5.12504 1.66602 6.61671 1.66602 8.45837V5.45C1.66602 3.75 3.04102 2.375 4.74102 2.375H9.42435C11.1243 2.375 12.4993 3.42504 12.4993 5.12504Z",
    fill: "#FCFCFD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "active-color-2",
    opacity: 0.4,
    d: "M14.566 10.1667C14.1493 10.575 13.9493 11.1916 14.116 11.8166C14.3243 12.5916 15.091 13.0833 15.891 13.0833H16.666V14.2917C16.666 16.1333 15.1743 17.625 13.3327 17.625H4.99935C3.15768 17.625 1.66602 16.1333 1.66602 14.2917V8.45833C1.66602 6.61667 3.15768 5.125 4.99935 5.125H13.3327C15.166 5.125 16.666 6.625 16.666 8.45833V9.66663H15.766C15.2993 9.66663 14.8743 9.84999 14.566 10.1667Z",
    fill: "#FCFCFD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "active-color-1",
    d: "M18.3329 10.516V12.2327C18.3329 12.6994 17.9495 13.0827 17.4745 13.0827H15.8662C14.9662 13.0827 14.1412 12.4244 14.0662 11.5244C14.0162 10.9994 14.2162 10.5077 14.5662 10.166C14.8745 9.84938 15.2995 9.66602 15.7662 9.66602H17.4745C17.9495 9.66602 18.3329 10.0494 18.3329 10.516Z",
    fill: "#FCFCFD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "active-color-1",
    d: "M10.834 9.91602H5.83398C5.49232 9.91602 5.20898 9.63268 5.20898 9.29102C5.20898 8.94935 5.49232 8.66602 5.83398 8.66602H10.834C11.1757 8.66602 11.459 8.94935 11.459 9.29102C11.459 9.63268 11.1757 9.91602 10.834 9.91602Z",
    fill: "#FCFCFD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet3);
export default __webpack_public_path__ + "static/media/wallet-3.302298254bfd8564d23855ff44544550.svg";
export { ForwardRef as ReactComponent };